import {
  DonationPageFirstFormResponseType,
  DonationPageThirdFormResponseType,
  DonationPageSecondFormResponseType,
  DonationPageResponseType,
  DonationPageTabsEnum,
  GlobalResponseType,
} from 'src/models/DonationPage/Section';
import {
  loadDonationPageFirstFormData,
  loadDonationPageThirdFormData,
  LoadDonationPageCheckoutSectionData,
} from 'src/pages/DonationSetup/containers/loadDataFromResponse';
import { DonationPageStateType } from 'src/pages/DonationSetup/containers/slice';

declare global {
  interface Window {
    donationSetupModel: GlobalResponseType & {
      CurrentSection: DonationPageResponseType['CurrentSection'];
    };
  }
}

export const loadDonationPageMock = (
  mode: DonationPageTabsEnum,
  sourceData: Window['donationSetupModel'],
  ignoreLocal = false
): {
  currentSectionData: DonationPageStateType['currentSectionData'];
  globalData: DonationPageStateType['globalData'];
} => {
  /** development only */
  if (process.env.NODE_ENV === 'development' && !ignoreLocal) {
    /** common data */
    const global: GlobalResponseType = {
      BenefitingUrl: 'sddsd',
      ID: 'e7999c',
      CampaignSetupChangedGroupName: null,
      NeedCreatePaymentProvideConfiguration: false,
      NeedRedirectToOrgSetup: false,
      NeedToCompleteAccount: false,
      NeedToSetupPartnerFunding: false,
      IsBenefitingOrganizationFrozen: false,
      CanAccessOrganizationVerifyAccountPage: false,
      Timeline: {
        IsVisible: true,
        Sections: [
          {
            ErrorCount: 0,
            IsActive: false,
            IsDisabled: false,
            IsValid: false,
            Progress: 80,
            SectionName: DonationPageTabsEnum.FIRST,
            SectionTitle: 'Donation Page',
          },
          {
            ErrorCount: 0,
            IsActive: true,
            IsDisabled: false,
            IsValid: false,
            Progress: 100,
            SectionName: DonationPageTabsEnum.SECOND,
            SectionTitle: 'Preference',
          },
          {
            ErrorCount: 0,
            IsActive: false,
            IsDisabled: false,
            IsValid: false,
            Progress: 100,
            SectionName: DonationPageTabsEnum.THIRD,
            SectionTitle: 'Advanced Options',
          },
        ],
      },
      CanSubmit: true,
      CampaignID: 9536,
      EditMode: 1,
      CampaignStatusID: 4,
      DisplayingStatusCode: 1,
      CurrentSection: {
        FundraisingActivityTypeCodes: [11],
        TerminologiesViewModel: {
          SupporterTerminologyModel: {
            DefaultTerminologies: [
              {
                ID: 28,
                Plural: 'Donors',
                Singular: 'Donor',
              },
              {
                ID: 29,
                Plural: 'Members',
                Singular: 'Member',
              },
              {
                ID: 30,
                Plural: 'Constituents',
                Singular: 'Constituent',
              },
              {
                ID: 27,
                Plural: 'Supporters',
                Singular: 'Supporter',
              },
            ],
            SelectedTerminology: {
              IsCampaignSpecific: true,
              ID: 29,
              Plural: 'Lols',
              Singular: 'Lol',
              Article: 'A',
            },
          },
          ContributionTerminologyModel: {
            DefaultTerminologies: [
              {
                ID: 33,
                Plural: 'Donations',
                Singular: 'Donation',
              },
              {
                ID: 34,
                Plural: 'Payments',
                Singular: 'Payment',
              },
              {
                ID: 35,
                Plural: 'Pledges',
                Singular: 'Pledge',
              },
              {
                ID: 36,
                Plural: 'Transactions',
                Singular: 'Transaction',
              },
              {
                ID: 398,
                Plural: 'Purchases',
                Singular: 'Purchase',
              },
              {
                ID: 32,
                Plural: 'Contributions',
                Singular: 'Contribution',
              },
            ],
            SelectedTerminology: {
              IsCampaignSpecific: true,
              ID: 36,
              Plural: 'ContribPlural',
              Singular: 'ContribSinguilar',
              Verb: 'ContribVerb',
              Article: 'An',
            },
          },
          ProjectTerminologyModel: {
            DefaultTerminologies: [
              {
                ID: 28,
                Plural: 'Donors',
                Singular: 'Donor',
              },
              {
                ID: 29,
                Plural: 'Members',
                Singular: 'Member',
              },
              {
                ID: 30,
                Plural: 'Constituents',
                Singular: 'Constituent',
              },
              {
                ID: 27,
                Plural: 'Supporters',
                Singular: 'Supporter',
              },
            ],
            SelectedTerminology: {
              IsCampaignSpecific: true,
              ID: 29,
              Plural: 'Lols',
              Singular: 'Lol',
              Article: 'A',
            },
          },
        },
        RunningOrganizationCommonName: 'running organization common name',
        CampaignName: 'campaign name campaign name campaign name campaign name campaign',
        PermanentUrl: 'e7999c',
        SectionName: DonationPageTabsEnum.FIRST,
      },
      CurrencyTypeID: 15,
    };

    // set common data at first
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    sourceData = global;

    if (mode === DonationPageTabsEnum.FIRST) {
      const data: DonationPageFirstFormResponseType = {
        ...sourceData,
        CurrentSection: {
          ...sourceData.CurrentSection,
          CurrencyTypeID: 16,
          CauseTerminology: {
            DefaultTerminologies: [
              {
                ID: 17,
                Plural: 'Funds',
                Singular: 'Fund',
              },
              {
                ID: 16,
                Plural: 'Causes',
                Singular: 'Cause',
              },
            ],
            SelectedTerminology: {
              IsCampaignSpecific: true,
              ID: 17,
              Plural: 'Funds',
              Singular: 'Fund',
              Article: 'A',
            },
          },
          ShortDescription: 'short descr',
          ShowCampaignHeadline: true,
          IsStartCampaignAutomatically: false,
          DesiredStartDate: '2021/10/20 00:00:00',
          DesiredStartTime: '23:59:00',
          DonationPageDisplayingConfigurationModel: {
            IsBannerEnabled: true,
            IsFundImageEnabled: true,
            IsPresetDonationDescriptionEnabled: true,
            IsPresetDonationImageEnabled: true,
            IsPresetDonationTitleEnabled: true,
          },
          Permissions: {
            CanAddImage: true,
            CanEditDonationLimits: true,
            CanEditCampaignPricing: true,
            CanEditChargingSettings: true,
            CanEditCheckInfo: true,
            CanEditCommonSettings: false,
            CanEditCurrencies: true,
            CanEditCutOffDate: false,
            CanEditDesiredStartDate: true,
            CanEditPaymentTypes: true,
            CanEditPresetContributionAmounts: true,
            CanEditPresets: false,
          },
          Medias: {
            ImagesRestrictions: {
              ImageHeight: 1020,
              ImageWidth: 1920,
            },
            Items: [
              {
                ID: 16698,
                ImageUri: 'https://s3.amazonaws.com/rallyup-campaigns/RallyUpDev/6fe349defb8cd23c7f49e3765c738709.jpg',
                IsEmpty: false,
                MediaType: 2,
              },
            ],
          },
          // ContributionButtonTerminology: {
          //   DefaultTerminologies: [
          //     {
          //       ID: 17,
          //       Text: 'Browse',
          //       IsDefault: true,
          //       FundraisingActivityTypeID: null,
          //     },
          //     {
          //       ID: 11,
          //       Text: 'Donate',
          //       IsDefault: true,
          //       FundraisingActivityTypeID: null,
          //     },
          //     {
          //       ID: 5,
          //       Text: 'Purchase',
          //       IsDefault: true,
          //       FundraisingActivityTypeID: null,
          //     },
          //     {
          //       ID: 4,
          //       Text: 'Give',
          //       IsDefault: true,
          //       FundraisingActivityTypeID: null,
          //     },
          //     {
          //       ID: 3,
          //       Text: 'Pay',
          //       IsDefault: true,
          //       FundraisingActivityTypeID: null,
          //     },
          //     {
          //       ID: 2,
          //       Text: 'Donate',
          //       IsDefault: true,
          //       FundraisingActivityTypeID: null,
          //     },
          //     {
          //       ID: 1,
          //       Text: 'Contribute',
          //       IsDefault: true,
          //       FundraisingActivityTypeID: null,
          //     },
          //   ],
          //   SelectedTerminology: {
          //     FundraisingActivityTypeID: null,
          //     ID: 1,
          //     IsDefault: true,
          //     Text: 'vwvwvwvwvwv',
          //   },
          // },
          ContributionAmountPresets: [
            {
              Amount: 45,
              ImageMedia: null,
              ID: 23,
              Sequence: 2,
              CampaignID: 9536,
              Title: '2121321421b4214b12n5456457jfgmgyu9i6789hjgmbcvnd5rt6767948dgfbnxcdrtfy58548',
              IsDefault: false,
              Description: null,
            },
          ],
          UseContributionAmountPresets: true,
          UseCauses: true,
          IsContributionPresetsSortDesc: true,
          SectionName: DonationPageTabsEnum.FIRST,
          Currencies: [
            {
              ID: 1,
              Name: 'United States dollar (USD)',
              Symbol: '$',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 5,
              Name: 'Australian dollar (AUD)',
              Symbol: '$',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 7,
              Name: 'Brazilian real (BRL)',
              Symbol: 'R$',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 2,
              Name: 'Canadian dollar (CAD)',
              Symbol: '$',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 8,
              Name: 'Danish krone (DKK)',
              Symbol: 'kr. ',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 4,
              Name: 'Euro (EUR)',
              Symbol: '€',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 9,
              Name: 'Hong Kong dollar (HKD)',
              Symbol: '$',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 16,
              Name: 'Indian rupee (INR)',
              Symbol: '₹',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 10,
              Name: 'Japanese yen (JPY)',
              Symbol: '¥',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 6,
              Name: 'New Zealand dollar (NZD)',
              Symbol: '$',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 12,
              Name: 'Norwegian krone (NOK)',
              Symbol: 'kr ',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 3,
              Name: 'Pound sterling (GBP)',
              Symbol: '£',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 13,
              Name: 'Singapore dollar (SGD)',
              Symbol: '$',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 14,
              Name: 'Swedish krona (SEK)',
              Symbol: 'kr ',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 15,
              Name: 'Swiss franc (CHF)',
              Symbol: 'Fr ',
              IsApplePayAndGooglePayAvailable: true,
            },
          ],
          IsAddressRequired: true,
          IsPhoneNumberRequired: true,
          // Countries: [
          //   {
          //     Disabled: false,
          //     Group: null,
          //     Selected: false,
          //     Text: 'Canada',
          //     Value: 'CA',
          //   },
          //   {
          //     Disabled: false,
          //     Group: null,
          //     Selected: false,
          //     Text: 'United States',
          //     Value: 'US',
          //   },
          //   {
          //     Disabled: false,
          //     Group: null,
          //     Selected: false,
          //     Text: 'Mexico',
          //     Value: 'MX',
          //   },
          //   {
          //     Disabled: false,
          //     Group: null,
          //     Selected: false,
          //     Text: 'United Kingdom',
          //     Value: 'GB',
          //   },
          //   {
          //     Disabled: false,
          //     Group: null,
          //     Selected: false,
          //     Text: 'Afghanistan',
          //     Value: 'AF',
          //   },
          //   {
          //     Disabled: false,
          //     Group: null,
          //     Selected: false,
          //     Text: 'Albania',
          //     Value: 'AL',
          //   },
          //   {
          //     Disabled: false,
          //     Group: null,
          //     Selected: false,
          //     Text: 'Algeria',
          //     Value: 'DZ',
          //   },
          //   {
          //     Disabled: false,
          //     Group: null,
          //     Selected: false,
          //     Text: 'Andorra',
          //     Value: 'AD',
          //   },
          //   {
          //     Disabled: false,
          //     Group: null,
          //     Selected: false,
          //     Text: 'Angola',
          //     Value: 'AO',
          //   },
          //   {
          //     Disabled: false,
          //     Group: null,
          //     Selected: false,
          //     Text: 'Antigua and Barbuda',
          //     Value: 'AG',
          //   },
          //   {
          //     Disabled: false,
          //     Group: null,
          //     Selected: false,
          //     Text: 'Argentina',
          //     Value: 'AR',
          //   },
          //   {
          //     Disabled: false,
          //     Group: null,
          //     Selected: false,
          //     Text: 'Armenia',
          //     Value: 'AM',
          //   },
          //   {
          //     Disabled: false,
          //     Group: null,
          //     Selected: false,
          //     Text: 'Australia',
          //     Value: 'AU',
          //   },
          //   {
          //     Disabled: false,
          //     Group: null,
          //     Selected: false,
          //     Text: 'Austria',
          //     Value: 'AT',
          //   },
          // ],
          // Check: {
          //   CheckAddressLine1: null,
          //   CheckAddressLine2: null,
          //   CheckAddressLine3: null,
          //   CheckAttentionTo: null,
          //   CheckCity: '',
          //   CheckCityID: null,
          //   CheckName: null,
          //   CheckPayableTo: null,
          //   CheckZipCode: '',
          //   CountryID: 'CA',
          //   RegionID: 56,
          // },
          // UsRegions: [
          //   {
          //     Abbreviation: 'AA',
          //     Country: 'United States',
          //     CountryID: null,
          //     DisplayName: 'AA - The Americas',
          //     ID: 69,
          //     Name: 'The Americas',
          //   },
          //   {
          //     Abbreviation: 'AK',
          //     Country: 'United States',
          //     CountryID: null,
          //     DisplayName: 'AK - Alaska',
          //     ID: 1,
          //     Name: 'Alaska',
          //   },
          // ],
          // CanadaRegions: [
          //   {
          //     Abbreviation: 'AB',
          //     Country: 'Canada',
          //     CountryID: null,
          //     DisplayName: 'AB - Alberta',
          //     ID: 56,
          //     Name: 'Alberta',
          //   },
          //   {
          //     Abbreviation: 'BC',
          //     Country: 'Canada',
          //     CountryID: null,
          //     DisplayName: 'BC - British Columbia',
          //     ID: 57,
          //     Name: 'British Columbia',
          //   },
          // ],
          EmailSubject: 'EmailSubject',
          EmailTemplate:
            // eslint-disable-next-line max-len
            '<p>Hello {FirstName} {LastName},</p>\r\n<br/>\r\n<p>Thank you for your generous donation! We truly appreciate your support.</p>\r\n<br />\r\n<p>Sincerely,</p>\r\n<p>{OrganizationName}</p>',
          // TextToGiveViewModel: {
          //   CanEditTextToGiveKeyword: true,
          //   ContributionButtonTerminology: 'Browse',
          //   IsSupported: true,
          //   IsTextToGiveEnabled: true,
          //   IsTextToGiveKeywordValid: false,
          //   PermanentUrl: 'b637b1',
          //   TextToGiveKeyword: 'asdasd4',
          // },
          FriendlyUrl: null,
        },
      };

      sourceData = data;
    } else if (mode === DonationPageTabsEnum.SECOND) {
      const data: DonationPageSecondFormResponseType = {
        ...sourceData,
        CurrentSection: {
          ...sourceData.CurrentSection,
          Permissions: {
            CanAddImage: true,
            CanEditDonationLimits: true,
            CanEditCampaignPricing: true,
            CanEditChargingSettings: true,
            CanEditCheckInfo: true,
            CanEditCommonSettings: false,
            CanEditCurrencies: true,
            CanEditCutOffDate: false,
            CanEditDesiredStartDate: true,
            CanEditPaymentTypes: true,
            CanEditPresetContributionAmounts: true,
            CanEditPresets: false,
          },
          PaymentMethods: [
            {
              IsEnabled: false,
              IsSelected: true,
              IsHidden: false,
              Name: 'Credit or Debit Card',
              Sequence: 1,
              SupportRecurringPayments: true,
              Value: 1,
            },
            {
              IsEnabled: true,
              IsHidden: true,
              IsSelected: true,
              Name: 'Apple Pay and Google Pay',
              Sequence: 2,
              SupportRecurringPayments: true,
              Value: 8,
            },
            {
              IsEnabled: true,
              IsSelected: true,
              IsHidden: false,
              Name: 'Check',
              Sequence: 5,
              SupportRecurringPayments: false,
              Value: 4,
            },
          ],
          SectionName: DonationPageTabsEnum.SECOND,
          Currencies: [
            {
              ID: 1,
              Name: 'United States dollar (USD)',
              Symbol: '$',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 5,
              Name: 'Australian dollar (AUD)',
              Symbol: '$',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 7,
              Name: 'Brazilian real (BRL)',
              Symbol: 'R$',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 2,
              Name: 'Canadian dollar (CAD)',
              Symbol: '$',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 8,
              Name: 'Danish krone (DKK)',
              Symbol: 'kr. ',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 4,
              Name: 'Euro (EUR)',
              Symbol: '€',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 9,
              Name: 'Hong Kong dollar (HKD)',
              Symbol: '$',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 16,
              Name: 'Indian rupee (INR)',
              Symbol: '₹',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 10,
              Name: 'Japanese yen (JPY)',
              Symbol: '¥',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 6,
              Name: 'New Zealand dollar (NZD)',
              Symbol: '$',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 12,
              Name: 'Norwegian krone (NOK)',
              Symbol: 'kr ',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 3,
              Name: 'Pound sterling (GBP)',
              Symbol: '£',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 13,
              Name: 'Singapore dollar (SGD)',
              Symbol: '$',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 14,
              Name: 'Swedish krona (SEK)',
              Symbol: 'kr ',
              IsApplePayAndGooglePayAvailable: true,
            },
            {
              ID: 15,
              Name: 'Swiss franc (CHF)',
              Symbol: 'Fr ',
              IsApplePayAndGooglePayAvailable: true,
            },
          ],
          IsAddressRequired: true,
          IsPhoneNumberRequired: true,
          Countries: [
            {
              Disabled: false,
              Group: null,
              Selected: false,
              Text: 'Canada',
              Value: 'CA',
            },
            {
              Disabled: false,
              Group: null,
              Selected: false,
              Text: 'United States',
              Value: 'US',
            },
            {
              Disabled: false,
              Group: null,
              Selected: false,
              Text: 'Mexico',
              Value: 'MX',
            },
            {
              Disabled: false,
              Group: null,
              Selected: false,
              Text: 'United Kingdom',
              Value: 'GB',
            },
            {
              Disabled: false,
              Group: null,
              Selected: false,
              Text: 'Afghanistan',
              Value: 'AF',
            },
            {
              Disabled: false,
              Group: null,
              Selected: false,
              Text: 'Albania',
              Value: 'AL',
            },
            {
              Disabled: false,
              Group: null,
              Selected: false,
              Text: 'Algeria',
              Value: 'DZ',
            },
            {
              Disabled: false,
              Group: null,
              Selected: false,
              Text: 'Andorra',
              Value: 'AD',
            },
            {
              Disabled: false,
              Group: null,
              Selected: false,
              Text: 'Angola',
              Value: 'AO',
            },
            {
              Disabled: false,
              Group: null,
              Selected: false,
              Text: 'Antigua and Barbuda',
              Value: 'AG',
            },
            {
              Disabled: false,
              Group: null,
              Selected: false,
              Text: 'Argentina',
              Value: 'AR',
            },
            {
              Disabled: false,
              Group: null,
              Selected: false,
              Text: 'Armenia',
              Value: 'AM',
            },
            {
              Disabled: false,
              Group: null,
              Selected: false,
              Text: 'Australia',
              Value: 'AU',
            },
            {
              Disabled: false,
              Group: null,
              Selected: false,
              Text: 'Austria',
              Value: 'AT',
            },
          ],
          Check: {
            CheckAddressLine1: null,
            CheckAddressLine2: null,
            CheckAddressLine3: null,
            CheckAttentionTo: null,
            CheckCity: '',
            CheckCityID: null,
            CheckName: null,
            CheckPayableTo: null,
            CheckZipCode: '',
            CountryID: 'CA',
            RegionID: 56,
          },
          UsRegions: [
            {
              Abbreviation: 'AA',
              Country: 'United States',
              CountryID: null,
              DisplayName: 'AA - The Americas',
              ID: 69,
              Name: 'The Americas',
            },
            {
              Abbreviation: 'AK',
              Country: 'United States',
              CountryID: null,
              DisplayName: 'AK - Alaska',
              ID: 1,
              Name: 'Alaska',
            },
          ],
          CanadaRegions: [
            {
              Abbreviation: 'AB',
              Country: 'Canada',
              CountryID: null,
              DisplayName: 'AB - Alberta',
              ID: 56,
              Name: 'Alberta',
            },
            {
              Abbreviation: 'BC',
              Country: 'Canada',
              CountryID: null,
              DisplayName: 'BC - British Columbia',
              ID: 57,
              Name: 'British Columbia',
            },
          ],
          EmailSubject: 'EmailSubject',
          EmailTemplate:
            // eslint-disable-next-line max-len
            '<p>Hello {FirstName} {LastName},</p>\r\n<br/>\r\n<p>Thank you for your generous donation! We truly appreciate your support.</p>\r\n<br />\r\n<p>Sincerely,</p>\r\n<p>{OrganizationName}</p>',
          TextToGiveViewModel: {
            CanEditTextToGiveKeyword: true,
            ContributionButtonTerminology: 'Browse',
            IsSupported: true,
            IsTextToGiveEnabled: true,
            IsTextToGiveKeywordValid: false,
            PermanentUrl: 'b637b1',
            TextToGiveKeyword: 'asdasd4',
            IsInternationalTextToGiveEnabled: false,
          },
          IsProPricingEnabled: false,
          DefaultPricingViewModel: {
            ShowPromoCodeFeeChargingTypeCode: false,
            PromoCodeFeeChargingTypeCode: 0,
            ShowDefaultPricingCard: true,
            IsTipPricingAvailable: false,
            ServiceFeePercent: 4,
            ServiceFeeRate: 40,
            PricingTypeCode: 3,
            DefaultPricingServiceFeeChargingTypeID: 1,
            DefaultPricingProcessingFeeChargingTypeID: 1,
            IsConvenienceFeeEnabled: true,
            ConvenienceFeeAmount: 5,
            ConvenienceFeeAmountType: 2,
            IsPercentageConvenienceFeeAvailable: true,
            PaymentProcessorTypeCodes: [1],
            IsVisible: true,
            CanChargeProcessingFeeToSupporter: true,
            ProcessingFeesChargedToSupporter: true,
            MaxPerItemFee: null,
            AuctionItemTerminologySingular: null,
            PartnerFundraisingActivityTypeServiceFeeRateID: 9,
            ServiceFeeChangedGroupName: 'LOCAL_CampaignServiceFeeChanged_12572',
          },
          PlusSubscriptionPricingViewModel: {
            IsVisible: false,
            ShowPlusSubscriptionPricingCard: true,
            PricingPlanName: 'RU+',
            DefaultPricingServiceFeeChargingTypeID: 2,
            DefaultPricingProcessingFeeChargingTypeID: 1,
            IsConvenienceFeeEnabled: false,
            ConvenienceFeeAmount: 5,
            ConvenienceFeeAmountType: 1,
            IsPercentageConvenienceFeeAvailable: true,
            ServiceFeeRate: 75,
            ServiceFeePercent: 7.5,
            CanChargeProcessingFeeToSupporter: true,
            ProcessingFeesChargedToSupporter: true,
            PaymentProcessorTypeCodes: [1],
            ShowFeePercent: true,
            ServiceFeeChangedGroupName: null,
          },
          AreFixedContributionsAllowed: true,
          AllowDonationDedication: true,
          UseCustomMinMaxContributionAmount: false,
          MinimumContributionAmount: 1,
          MaximumContributionAmount: 2,
          CustomFields: {
            BasicFields: [],
            CustomFields: [
              {
                ID: 41,
                Name: '123',
                IsRequired: false,
                Collect: false,
                Sequence: 1,
                CustomFieldTypeID: 1,
                Readonly: false,
                IsCustom: false,
                HasOtherOption: false,
                Options: [],
                HasNonEmptyValues: false,
              },
            ],
            Types: [
              {
                Code: 1,
                Name: 'ShortText',
              },
              {
                Code: 2,
                Name: 'Paragraph',
              },
              {
                Code: 3,
                Name: 'Decimal',
              },
              {
                Code: 4,
                Name: 'RadioGroup',
              },
              {
                Code: 5,
                Name: 'Dropdown',
              },
              {
                Code: 6,
                Name: 'Checkbox',
              },
              {
                Code: 7,
                Name: 'Phone',
              },
              {
                Code: 8,
                Name: 'Date',
              },
              {
                Code: 9,
                Name: 'Time',
              },
            ],
          },
          EnableMarketingEmailsOption: false,
          EnableMarketingEmailsOptionLabel: 'EnableMarketingEmailsOptionLabel',
          IsInTestMode: false,
        },
      };

      sourceData = data;
    } else if (mode === DonationPageTabsEnum.THIRD) {
      const data: DonationPageThirdFormResponseType = {
        ...sourceData,
        CurrentSection: {
          ...sourceData.CurrentSection,
          EnableAnonymousDonation: false,
          EnableHideEmail: false,
          TimezoneID: 80,
          Timezones: [
            {
              ID: 1,
              Name: '(GMT-12:00) International Date Line West',
            },
            {
              ID: 2,
              Name: '(GMT-11:00) Midway Island, Samoa',
            },
            {
              ID: 3,
              Name: '(GMT-10:00) Hawaii',
            },
            {
              ID: 4,
              Name: '(GMT-09:00) Alaska',
            },
            {
              ID: 5,
              Name: '(GMT-08:00) Pacific Time (US & Canada)',
            },
            {
              ID: 6,
              Name: '(GMT-07:00) Tijuana, Baja California',
            },
            {
              ID: 7,
              Name: '(GMT-07:00) Mountain Time (US & Canada)',
            },
            {
              ID: 8,
              Name: '(GMT-07:00) Chihuahua, La Paz, Mazatlan',
            },
            {
              ID: 9,
              Name: '(GMT-07:00) Arizona',
            },
            {
              ID: 10,
              Name: '(GMT-06:00) Saskatchewan',
            },
            {
              ID: 11,
              Name: '(GMT-06:00) Central America',
            },
            {
              ID: 12,
              Name: '(GMT-06:00) Central Time (US & Canada)',
            },
            {
              ID: 13,
              Name: '(GMT-06:00) Guadalajara, Mexico City, Monterrey',
            },
            {
              ID: 14,
              Name: '(GMT-05:00) Eastern Time (US & Canada)',
            },
            {
              ID: 15,
              Name: '(GMT-05:00) Bogota, Lima, Quito, Rio Branco',
            },
            {
              ID: 16,
              Name: '(GMT-05:00) Indiana (East)',
            },
            {
              ID: 17,
              Name: '(GMT-04:30) Caracas',
            },
            {
              ID: 18,
              Name: '(GMT-04:00) Atlantic Time (Canada)',
            },
            {
              ID: 19,
              Name: '(GMT-04:00) Manaus',
            },
            {
              ID: 20,
              Name: '(GMT-04:00) Santiago',
            },
            {
              ID: 21,
              Name: '(GMT-04:00) La Paz',
            },
            {
              ID: 22,
              Name: '(GMT-03:30) Newfoundland',
            },
            {
              ID: 23,
              Name: '(GMT-03:00) Brasilia',
            },
            {
              ID: 24,
              Name: '(GMT-03:00) Greenland',
            },
            {
              ID: 25,
              Name: '(GMT-03:00) Montevideo',
            },
            {
              ID: 26,
              Name: '(GMT-03:00) Buenos Aires, Georgetown',
            },
            {
              ID: 27,
              Name: '(GMT-02:00) Mid-Atlantic',
            },
            {
              ID: 28,
              Name: '(GMT-01:00) Azores',
            },
            {
              ID: 29,
              Name: '(GMT-01:00) Cape Verde Is.',
            },
            {
              ID: 30,
              Name: '(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London',
            },
            {
              ID: 31,
              Name: '(GMT) Casablanca, Monrovia, Reykjavik',
            },
            {
              ID: 32,
              Name: '(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
            },
            {
              ID: 33,
              Name: '(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
            },
            {
              ID: 34,
              Name: '(GMT+01:00) Brussels, Copenhagen, Madrid, Paris',
            },
            {
              ID: 35,
              Name: '(GMT+01:00) West Central Africa',
            },
            {
              ID: 36,
              Name: '(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
            },
            {
              ID: 37,
              Name: '(GMT+02:00) Minsk',
            },
            {
              ID: 38,
              Name: '(GMT+02:00) Cairo',
            },
            {
              ID: 39,
              Name: '(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
            },
            {
              ID: 40,
              Name: '(GMT+02:00) Athens, Bucharest, Istanbul',
            },
            {
              ID: 41,
              Name: '(GMT+02:00) Jerusalem',
            },
            {
              ID: 42,
              Name: '(GMT+02:00) Amman',
            },
            {
              ID: 43,
              Name: '(GMT+02:00) Beirut',
            },
            {
              ID: 44,
              Name: '(GMT+02:00) Windhoek',
            },
            {
              ID: 45,
              Name: '(GMT+02:00) Harare, Pretoria',
            },
            {
              ID: 46,
              Name: '(GMT+03:00) Kuwait, Riyadh',
            },
            {
              ID: 47,
              Name: '(GMT+03:00) Baghdad',
            },
            {
              ID: 48,
              Name: '(GMT+03:00) Nairobi',
            },
            {
              ID: 49,
              Name: '(GMT+03:00) Tbilisi',
            },
            {
              ID: 50,
              Name: '(GMT+03:00) Moscow, St. Petersburg, Volgograd',
            },
            {
              ID: 51,
              Name: '(GMT+03:30) Tehran',
            },
            {
              ID: 52,
              Name: '(GMT+04:00) Abu Dhabi, Muscat',
            },
            {
              ID: 53,
              Name: '(GMT+04:00) Baku',
            },
            {
              ID: 54,
              Name: '(GMT+04:00) Yerevan',
            },
            {
              ID: 55,
              Name: '(GMT+04:30) Kabul',
            },
            {
              ID: 56,
              Name: '(GMT+05:00) Ekaterinburg',
            },
            {
              ID: 57,
              Name: '(GMT+05:00) Islamabad, Karachi, Tashkent',
            },
            {
              ID: 58,
              Name: '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi',
            },
            {
              ID: 59,
              Name: '(GMT+05:30) Sri Jayawardenepura',
            },
            {
              ID: 60,
              Name: '(GMT+05:45) Kathmandu',
            },
            {
              ID: 61,
              Name: '(GMT+06:00) Astana, Dhaka',
            },
            {
              ID: 62,
              Name: '(GMT+06:00) Almaty',
            },
            {
              ID: 63,
              Name: '(GMT+06:30) Yangon (Rangoon)',
            },
            {
              ID: 64,
              Name: '(GMT+07:00) Krasnoyarsk, Novosibirsk',
            },
            {
              ID: 65,
              Name: '(GMT+07:00) Bangkok, Hanoi, Jakarta',
            },
            {
              ID: 66,
              Name: '(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
            },
            {
              ID: 67,
              Name: '(GMT+08:00) Irkutsk, Ulaan Bataar',
            },
            {
              ID: 68,
              Name: '(GMT+08:00) Kuala Lumpur, Singapore',
            },
            {
              ID: 69,
              Name: '(GMT+08:00) Taipei',
            },
            {
              ID: 70,
              Name: '(GMT+08:00) Perth',
            },
            {
              ID: 71,
              Name: '(GMT+09:00) Seoul',
            },
            {
              ID: 72,
              Name: '(GMT+09:00) Osaka, Sapporo, Tokyo',
            },
            {
              ID: 73,
              Name: '(GMT+09:00) Yakutsk',
            },
            {
              ID: 74,
              Name: '(GMT+09:30) Darwin',
            },
            {
              ID: 75,
              Name: '(GMT+09:30) Adelaide',
            },
            {
              ID: 76,
              Name: '(GMT+10:00) Canberra, Melbourne, Sydney',
            },
            {
              ID: 77,
              Name: '(GMT+10:00) Brisbane',
            },
            {
              ID: 78,
              Name: '(GMT+10:00) Hobart',
            },
            {
              ID: 79,
              Name: '(GMT+10:00) Vladivostok',
            },
            {
              ID: 80,
              Name: '(GMT+10:00) Guam, Port Moresby',
            },
            {
              ID: 81,
              Name: '(GMT+11:00) Magadan, Solomon Is., New Caledonia',
            },
            {
              ID: 82,
              Name: '(GMT+12:00) Fiji, Kamchatka, Marshall Is.',
            },
            {
              ID: 83,
              Name: '(GMT+12:00) Auckland, Wellington',
            },
            {
              ID: 84,
              Name: "(GMT+13:00) Nuku'alofa",
            },
          ],
          // Permissions: {
          //   CanAllowDonationsDirectlyToOrganization: true,
          //   CanChooseParentCampaign: false,
          //   CanEditAdministrators: true,
          //   CanEditAnonymityOfContributions: true,
          //   CanEditChargingSettings: true,
          //   CanEditCheckInfo: false,
          //   CanEditCloseOnGoal: true,
          //   CanEditCommonSettings: false,
          //   CanEditContributionsDuration: false,
          //   CanEditCustomFields: true,
          //   CanEditCutOffDate: false,
          //   CanEditDedicationOfContributions: true,
          //   CanEditDonationLimits: true,
          //   CanEditOrganizerPromoCode: false,
          //   CanEditPaymentTypes: false,
          //   CanEditPresetContributionAmounts: true,
          //   CanEditPresets: false,
          //   CanEditRegistrationNotice: true,
          //   CanEditTeamMemberRegistrationEndDate: true,
          //   CanEditTeamMemberResistartionStartDate: true,
          //   CanEnableAttributes: false,
          //   CanTurnOnSpecialInstructions: true,
          // },
          SectionName: DonationPageTabsEnum.THIRD,
          FundCode: 'FundCode',
          HaveFundCode: true,
          UkGiftAidShown: true,
          IsUkGiftAidEnabled: false,
          GiftAidStatement:
            // eslint-disable-next-line max-len
            '<p>Boost your donation by 25p of Gift Aid for every &pound;1 you donate!</p><p><br></p><p>Gift Aid is reclaimed by the charity from the tax you pay for the current tax year. Your address is needed to identify you as a current UK taxpayer.</p><p><br></p><p>Check the box below to Gift Aid your donation. By doing so, you are claiming that you are a UK taxpayer and understand that if you pay less Income Tax and/or Capital Gains Tax than the amount of Gift Aid claimed on all your donations in that tax year, it is your responsibility to pay any difference.</p>',
          GiftAidAgreement:
            // eslint-disable-next-line max-len
            'I want to Gift Aid my donation of {Amount} and any donations I make in the future or have made in the past 4 years to Dagdusheth Halwai Ganpati',
          PricingViewModel: {
            ShowOrganizerPromoCode: true,
            HaveOrganizerPromoCode: true,
            OrganizerPromoCode: null,
            OrganizerPromoCodeString: null,
          },
          ContributionBankStatement: 'contributionBankState',
          CanHaveAdditionalAmount: true,
          ShowAdditionalAmount: true,
          IsPledge: true,
          AreFixedContributionsAllowedVisible: true,
          AreFixedContributionsAllowed: true,
          IsDonationWithoutItemsHeadlineAndButtonVisible: true,
          DonationWithoutItemsHeadLineText: 'DonationWithoutItemsHeadLineText',
          DonateWithoutItemsButtonText: 'DonateWithoutItems',
          ShowAreCompleteAnonymousContributions: true,
          AreCompleteAnonymousContributionsDisabled: true,
          AllowDonationDedication: true,
          ShowSpecialInstructions: true,
          IsSpecialInstructionsVisible: true,
          UseCustomMinMaxContributionAmount: false,
          MinimumContributionAmount: 1,
          MaximumContributionAmount: 2,
          EnableMarketingEmailsOption: false,
          EnableMarketingEmailsOptionLabel: 'EnableMarketingEmailsOptionLabel',
          Notice: null,
          IsSupporterNoticeAcknowledgmentRequired: false,
          ContributionNotificationRecipients: [
            { Email: 'contry1@y.ru' },
            { Email: 't1@t.tu' },
            { Email: 'wrongemail.jp' },
          ],
          ContactOrganizerEmailRecipients: [{ Email: 'y@y.ru' }, { Email: 't@t.tu' }, { Email: 'wrongemail2' }],
          AreNotificationsAboutNewDonorsAndDonationsEnabled: true,
          AllowRecurringDonations: true,
          HasRecurringContributions: false,
          DefaultRecurrencePeriodID: 0,
          AllowDonorsChooseRecurringDonationFrequency: true,
          IsRecurringDonationUpsellEnabled: true,
          UpsellPercentage: 40,
          UpsellTitle: 'UpsellTitle',
          UpsellDescription: 'UpsellDescription',
          IsVisibleIntegrationSection: true,
          IntegrationsOptionsSubsectionViewModel: {
            BloomerangFields: {
              IsVisible: true,
              CampaignFieldValues: [
                {
                  Id: 1,
                  Name: 'test campaign',
                  FieldTypeID: 1,
                },
              ],
              CampaignFieldValueID: null,
              FundFieldValues: [
                {
                  Id: 1,
                  Name: 'test fund',
                  FieldTypeID: 2,
                },
              ],
              FundFieldValueID: null,
              AppealFieldValues: [
                {
                  Id: 1,
                  Name: 'test appeal',
                  FieldTypeID: 3,
                },
              ],
              AppealFieldValueID: null,
              BloomerangFieldsUpdatedGroupName: 'test_group_name_b',
            },
            LittleGreenLightFields: {
              IsVisible: true,
              CampaignFieldValues: [
                {
                  Id: 1,
                  Name: 'test campaign',
                  FieldTypeID: 1,
                },
              ],
              CampaignFieldValueID: null,
              FundFieldValues: [
                {
                  Id: 1,
                  Name: 'test fund',
                  FieldTypeID: 2,
                },
              ],
              FundFieldValueID: null,
              AppealFieldValues: [
                {
                  Id: 1,
                  Name: 'test appeal',
                  FieldTypeID: 3,
                },
              ],
              AppealFieldValueID: null,
              LittleGreenLightFieldsUpdatedGroupName: 'test_group_name_l',
            },
            OrganizationId: 1,
          },
        },
      };

      sourceData = data;
    }
  }

  const currentSection = sourceData.CurrentSection;

  let currentSectionData: DonationPageStateType['currentSectionData'] = null;

  switch (mode) {
    case DonationPageTabsEnum.FIRST:
      currentSectionData = loadDonationPageFirstFormData(
        currentSection as DonationPageFirstFormResponseType['CurrentSection'],
        sourceData.CurrencyTypeID
      );

      break;
    case DonationPageTabsEnum.SECOND:
      currentSectionData = LoadDonationPageCheckoutSectionData(
        currentSection as DonationPageSecondFormResponseType['CurrentSection'],
        sourceData.CurrencyTypeID,
        sourceData.currencyType
      );
      break;
    case DonationPageTabsEnum.THIRD:
      currentSectionData = loadDonationPageThirdFormData(
        currentSection as DonationPageThirdFormResponseType['CurrentSection'],
        sourceData.CurrencyTypeID,
        sourceData.currencyType
      );
      break;
    default:
      break;
  }

  return {
    globalData: {
      CampaignSetupChangedGroupName: sourceData.CampaignSetupChangedGroupName,
      NeedCreatePaymentProvideConfiguration: sourceData.NeedCreatePaymentProvideConfiguration,
      NeedRedirectToOrgSetup: sourceData.NeedRedirectToOrgSetup,
      NeedToCompleteAccount: sourceData.NeedToCompleteAccount,
      NeedToSetupPartnerFunding: sourceData.NeedToSetupPartnerFunding,
      IsBenefitingOrganizationFrozen: sourceData.IsBenefitingOrganizationFrozen,
      CanAccessOrganizationVerifyAccountPage: sourceData.CanAccessOrganizationVerifyAccountPage,
      benefitingUrl: sourceData.BenefitingUrl,
      ID: sourceData.ID,
      canSubmit: sourceData.CanSubmit,
      campaignName: sourceData.CurrentSection.CampaignName,
      runningOrganizationCommonName: sourceData.CurrentSection.RunningOrganizationCommonName,
      campaignID: sourceData.CampaignID,
      fundraisingActivityTypeCodes: sourceData.CurrentSection.FundraisingActivityTypeCodes,
      editMode: sourceData.EditMode,
      statusID: sourceData.CampaignStatusID,
      DisplayingStatusCode: sourceData.DisplayingStatusCode,
      permanentUrl: sourceData.CurrentSection.PermanentUrl,
      timeline: {
        visible: sourceData.Timeline.IsVisible,
        sections: sourceData.Timeline.Sections.map((rawSection) => ({
          name: rawSection.SectionName,
          disabled: rawSection.IsDisabled,
          title: rawSection.SectionTitle,
          progress: rawSection.Progress,
          errorCount: rawSection.ErrorCount,
        })),
      },
    },
    currentSectionData,
  };
};
